export const LAST_SEARCHES_LOADED_EVENT = 'last-searches:loaded'
